import { Input } from 'src/components/widgets/input';
import { FormControl } from '../../../../../widgets/formControl';
import React from 'react';
import { RowActionButton } from 'src/shared/globals';
import { T, validateInputSecurity } from 'src/shared/helpers';
import { validateRequired } from 'src/shared/validation';
import styled from 'styled-components';
import { addSideAction, editSideNameAction, removeSideAction, useProductConfigurationState } from '../../../state';
import { useResizablePrintAreaContext } from './resizablePrintAreaContext';
import ResizableSideTypeSection from './resizableSideTypeSection';
import { Icon } from 'src/components/widgets/icon';
import MaterialAddCircleSvg from 'src/shared/material_icons/content/add_circle.svg';
import MaterialDeleteSvg from 'src/shared/material_icons/action/delete.svg';
const ResizableSideContainer = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;

    > span {
        margin-bottom: 8px;
    }
`;

const FormControlSideStyled = styled(FormControl)`
    margin-bottom: 4px !important;
`;

const ResizableSideInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;

    input {
        flex: 1;
    }
`;

const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
`;

const SideActionIcon = styled(Icon)``;

const VerticalSeparator = styled.div`
    width: 0px;
    height: 24px;
    border: 1px solid rgba(0, 0, 0, 0.1);
`;

const ResizableSideSection = () => {
    const { state, dispatch } = useProductConfigurationState();
    const { sideType, setSideType } = useResizablePrintAreaContext();

    const sides = state.sides;

    const handleDeleteSide = (idx: number) => {
        if (idx === 0) return;

        if (state.sides.length === 2) {
            setSideType('single');
        }

        const side = state.sides[idx];
        dispatch(removeSideAction(side));
    };

    const handleChangeSide = (value: string, idx: number) => {
        const side = state.sides[idx];
        const modelColor = state.product.colors.find((x) => x.colorID === 1);
        if (!modelColor) return;
        const modelSide = modelColor.sides.find((x) => x.originalSideGuid === side.guid);
        if (!modelSide) return;

        dispatch(editSideNameAction(modelSide, value));
    };

    const handleAddSide = (idx: number) => {
        if (idx !== sides.length - 1) return;
        dispatch(addSideAction(''));
    };

    return (
        <>
            <ResizableSideTypeSection />
            <ResizableSideContainer>
                <span>{T._('Side name', 'Admin')}</span>
                {sides.map((side, i) => (
                    <ResizableSideInputContainer key={i}>
                        <FormControlSideStyled label=''>
                            <Input
                                type='text'
                                validationKey={`side${i}`}
                                validate={(value) => validateRequired(value) || !validateInputSecurity(value).isValid}
                                message={`${validateRequired(side.name) ? T._('Side name is required.', 'Admin') : !validateInputSecurity(side.name).isValid ? T._(`Invalid characters detected: ${validateInputSecurity(side.name).invalidCharacters.join(', ')}`, 'Admin') : ''}`}
                                onChange={(value) => handleChangeSide(value.target.value, i)}
                                value={side.name}
                                fullWidth
                            />
                        </FormControlSideStyled>
                        {(sideType === 'multiple' || sideType === 'multiplesyn') && (
                            <IconContainer>
                                <RowActionButton disabled={i === 0} onClick={() => handleDeleteSide(i)} aria-label={T._('Delete side', 'Admin')}>
                                    <SideActionIcon>
                                        <MaterialDeleteSvg />
                                    </SideActionIcon>
                                </RowActionButton>
                                <VerticalSeparator />
                                <RowActionButton disabled={i !== sides.length - 1} onClick={() => handleAddSide(i)} aria-label={T._('Add new side', 'Admin')}>
                                    <SideActionIcon>
                                        <MaterialAddCircleSvg />
                                    </SideActionIcon>
                                </RowActionButton>
                            </IconContainer>
                        )}
                    </ResizableSideInputContainer>
                ))}
            </ResizableSideContainer>
        </>
    );
};

export default ResizableSideSection;
